import MoreHoriz from "@material-symbols/svg-500/rounded/more_horiz.svg?react";
import { memo } from "react";

import { IconCreator } from "./_utils/icon-creator";

import type { SVGIconProps } from "./_utils/icon-creator";

const ThreeDotsHorizontalIcon = (props: SVGIconProps) => {
	const Icon = () => IconCreator({ ...props, svgIcon: MoreHoriz });
	return <Icon />;
};

export default memo(ThreeDotsHorizontalIcon);
